module.exports = __webpack_public_path__ + "img/profile.eb38b363.jpg";